import React from 'react';
import CardBalanceDepositar from '../../../card/CardBalanceDepositar'

import Send from '../../../../assets/img/send/quicksend.png'
import Group from '../../../../assets/img/send/group.png'

import Excel from '../../../../assets/img/send/excel.png'



const SelectBuyColurs = ({

    balanceBanck = 'Selecciona un usuario a quién quieres enviar tu saldo',
    balanceColurs = 'Envía a varios usuarios al mismo tiempo',
    balanceUSDT = "Anexa la plantilla de Colurs diligenciada previamente",

    labelBanck = "Envío Rápido",
    labelUsd = "Dispersión Múltiple",
    labelColurs = "Envío Masivo",

    FastSendButton,
    GroupSendButton,
    ExcelButton,


}) => {

    return (
        <>
            {< p className='w-full flex mt-4 text-base font-normal text-[#B7B7B9] traking-[-0.14px] leading-5 ' >Selecciona una opción para dispersar </p >}

            <div className='w-full h-full flex items-center gap-2 justify-center py-4  ' >

                {<>
                    <CardBalanceDepositar icon={Send} balance={balanceBanck} hover={true} textBalance={'text-[14px]'} label={labelBanck} onClick={FastSendButton} />
                    <CardBalanceDepositar icon={Group} balance={balanceUSDT} hover={true} textBalance={'text-[14px]'} label={labelUsd} onClick={GroupSendButton} />
                    {/*                     <CardBalanceDepositar icon={Excel} balance={balanceColurs} hover={true} textBalance={'text-[14px]'} label={labelColurs} onClick={ExcelButton} />
 */}                </>}
            </div>
        </>
    );
};

export default SelectBuyColurs;
